import { render } from "./VabeneOrderList.vue?vue&type=template&id=f1ab5820&ts=true"
import script from "./VabeneOrderList.vue?vue&type=script&lang=ts"
export * from "./VabeneOrderList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__